<div
    class="header-area bg-white box-shadow transition"
    [ngClass]="{'active': isToggled}"
>
    <div class="d-md-flex align-items-center justify-content-between">
        <div class="header-left-side d-flex align-items-center">
            <div
                class="burger-menu position-relative transition lh-1"
                [ngClass]="{'active': isToggled}"
                (click)="toggleSideBar()"
            >
                <i-feather name="align-left"></i-feather>
            </div>
            <!-- <form class="search-box position-relative">
                <input type="text" class="input-search w-100 d-block border-none" placeholder="Search here..">
                <button type="submit" class="bg-transparent p-0 border-none transition">
                    <i-feather name="search"></i-feather>
                </button>
            </form> -->
        </div>
        <ul class="header-right-side d-flex align-items-center m-0 p-0 list-unstyled">
            <li>
                <button
                    mat-button
                    (click)="toggleTheme()"
                    class="dark-swtich-btn"
                    [class.active]="toggleService.isDark()"
                >
                    <i-feather name="moon"></i-feather>
                </button>
            </li>

            <!-- <li>
                <div class="date-btn position-relative">
                    <i-feather name="calendar"></i-feather> {{ formattedDate }}
                </div>
            </li> -->
            <li>
                <button mat-button [matMenuTriggerFor]="profileMenu" class="profile-menu-btn">
                    <div class="initials-circle">{{ initials }}</div>
                </button>
                <mat-menu class="profile-menu-dropdown" #profileMenu="matMenu" xPosition="before">
                    <!-- <div class="menu-header d-flex align-items-center">
                        <img src="assets/images/admin.jpg" class="rounded-circle" alt="admin-image">
                        <div class="title">
                            <a routerLink="/main/profile" class="d-inline-block fw-medium">
                                Daniel Lungu - ADMIN
                            </a>
                            <span class="designation d-block text-body">
                                Admin
                            </span>
                        </div>
                    </div> -->
                    <ul class="menu-body pl-0 mb-0 mt-0 list-unstyled">
                        <li class="position-relative transition fw-medium">
                            <i class="material-symbols-outlined">
                                person
                            </i>
                            My Profile
                            <a routerLink="/main/profile" class="link-btn d-block position-absolute left-0 right-0 top-0 bottom-0 z-1"></a>
                        </li>
                        
                        <li class="position-relative transition fw-medium">
                            <i class="material-symbols-outlined">
                                logout
                            </i>
                            Logout
                            <a (click)="logoutClicked()" routerLink="/" class="link-btn d-block position-absolute left-0 right-0 top-0 bottom-0 z-1"></a>
                        </li>
                    </ul>
                </mat-menu>
            </li>
        </ul>
    </div>
</div>
